import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Sparkles, Download } from 'lucide-react';

export default function InspirationViewerModal({
  inspiration,
  onClose,
  language,
  challengeCategoryLabel = null,
}) {
  if (!inspiration) return null;

  const handleDownload = async () => {
    try {
      const response = await fetch(inspiration.imageUrl);
      if (!response.ok) return;
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `colobongo-inspiration-${inspiration.id}.png`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch {
      // silent fail - download is optional
    }
  };

  return (
    <AnimatePresence>
      {inspiration && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          className="fixed inset-0 bg-black/90 z-[80] flex flex-col"
          onClick={onClose}
        >
          {/* Header */}
          <div className="flex items-center justify-between p-4 bg-gradient-to-b from-black/60 to-transparent">
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 text-white">
                <Sparkles size={16} className="text-[color:var(--cb-primary)]" />
                <span className="text-sm font-bold truncate">
                  {language === 'fr' ? 'Inspiration AI' : 'AI Inspiration'}
                </span>
              </div>
              {challengeCategoryLabel && (
                <p className="text-xs text-white/70 mt-0.5 truncate">
                  {challengeCategoryLabel}
                </p>
              )}
            </div>
            <motion.button
              type="button"
              onClick={onClose}
              className="p-2 rounded-full bg-white/20 text-white ml-2"
              whileTap={{ scale: 0.9 }}
              aria-label={language === 'fr' ? 'Fermer' : 'Close'}
            >
              <X size={22} />
            </motion.button>
          </div>

          {/* Image - plein écran mobile-first */}
          <div
            className="flex-1 flex items-center justify-center px-3 py-2"
            onClick={(e) => e.stopPropagation()}
          >
            <motion.img
              src={inspiration.imageUrl}
              alt={language === 'fr' ? 'Inspiration AI en grand' : 'AI inspiration full view'}
              className="max-w-full max-h-full object-contain rounded-xl"
              initial={{ scale: 0.92, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              transition={{ type: 'spring', damping: 22, stiffness: 180 }}
            />
          </div>

          {/* Footer actions */}
          <div
            className="p-4 bg-gradient-to-t from-black/60 to-transparent flex justify-center gap-3"
            onClick={(e) => e.stopPropagation()}
          >
            <motion.button
              onClick={handleDownload}
              className="flex items-center gap-2 px-5 py-3 rounded-full bg-white text-[color:var(--cb-text)] font-semibold text-sm"
              whileTap={{ scale: 0.95 }}
            >
              <Download size={16} />
              {language === 'fr' ? 'Télécharger' : 'Download'}
            </motion.button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
